import type { HpPetSize } from '@zg-rentals/ts-hotpads-api-client';

// Keyed by the generated HpPetSize, so tsc fails here when hotpads-api adds or drops a size.
// Key order is sort order; `all` is the rule for every size, so it sorts after them.
const PET_SIZE_KEYS = {
  tiny: true,
  small: true,
  medium: true,
  large: true,
  huge: true,
  all: true,
} as const satisfies Record<`${HpPetSize}`, true>;

const PET_SIZE_ORDER: ReadonlyArray<string> = Object.keys(PET_SIZE_KEYS);

export type PetSize = Exclude<keyof typeof PET_SIZE_KEYS, 'all'>;

export const isPetSize = (value: string): value is PetSize => value !== 'all' && Object.hasOwn(PET_SIZE_KEYS, value);

export function petSizeSortRank(petSize: string | null | undefined): number {
  const rank = PET_SIZE_ORDER.indexOf(petSize?.toLowerCase() ?? '');
  return rank === -1 ? PET_SIZE_ORDER.length : rank;
}
